import { AlertCircle, CheckCircle2, Info, MessageCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

const ICONE = {
  default: <CheckCircle2 className="mt-px h-4 w-4 shrink-0 text-[#075E54] dark:text-[#25D366]" />,
  destructive: <AlertCircle className="mt-px h-4 w-4 shrink-0 text-[#5B0A0D] dark:text-[#C87484]" />,
  warning: <Info className="mt-px h-4 w-4 shrink-0 text-[#7A2235] dark:text-[#C87484]" />,
  whatsapp: <MessageCircle className="mt-px h-4 w-4 shrink-0 text-[hsl(142,70%,35%)]" />,
  claro: <Info className="mt-px h-4 w-4 shrink-0 text-[hsl(356,100%,45%)]" />,
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            {ICONE[props.variant ?? "default"]}
            <div className="grid min-w-0 flex-1 gap-0.5">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
